import {combineReducers} from "redux";

import whychooseus from "../features/admin/aboutus/whychooseus/Slice";

import whatourclientsay from "../features/admin/aboutus/whatourclientsay/Slice";

import aboutfalcon from "../features/admin/aboutus/about_falcon/Slice";

import common from "../features/admin/common/Slice";

const aboutus = combineReducers({    
    whychooseus,    
    whatourclientsay,    
    aboutfalcon,
    common
});

export default aboutus;